import mark from '@brand/logo/mark.svg?raw';
import { tenant } from '../lib/tenant';

export interface BrandMarkProps {
  size?: number;
}

/** The BirFlyPermit mark alone (wing + risers + pilot dot), inlined from packages/brand so it can take `currentColor`. */
export function BrandMark({ size = 32 }: BrandMarkProps) {
  return (
    <span
      class="c-brand-mark"
      style={{ width: size, height: size, display: 'inline-flex' }}
      dangerouslySetInnerHTML={{ __html: mark }}
    />
  );
}

export interface BrandLockupProps {
  /** Ink-only variant — used on the footer, over the same light surface as the header. */
  mono?: boolean;
  /** Sizing preset: `header` (topbar/nav, default), `footer` (slightly smaller) or `hero` (large, for a page hero). */
  size?: 'header' | 'footer' | 'hero';
  /** Mark + wordmark only, no tagline line — used in the mobile topbar where height is tight. */
  compact?: boolean;
}

/**
 * The "BirFlyPermit — Free Flyer Card, Bir Billing" lockup — used in the top bar and footer. Built
 * from the mark SVG plus live text (not a flattened SVG lockup) so the wordmark, Devanagari and
 * tagline can each be sized independently per the design brief and the tagline can read the
 * active tenant's own copy (`product.cardName` · `office.site`) instead of being hard-coded.
 */
export function BrandLockup({ mono = false, size = 'header', compact = false }: BrandLockupProps) {
  const classes = ['c-brand-lockup', `c-brand-lockup--${size}`, mono ? 'c-brand-lockup--mono' : ''].filter(Boolean).join(' ');
  return (
    <span class={classes}>
      <span class="c-brand-lockup__mark" aria-hidden="true" dangerouslySetInnerHTML={{ __html: mark }} />
      <span class="c-brand-lockup__text">
        <span class="c-brand-lockup__wordmark">
          {tenant.product.name}
          <span class="c-brand-lockup__devanagari" lang="hi">
            बीर फ़्लाई परमिट
          </span>
        </span>
        {compact ? null : (
          <span class="c-brand-lockup__tagline">
            {tenant.product.cardName} · {tenant.office.site}
          </span>
        )}
      </span>
    </span>
  );
}
